module.exports = require('./dist/client/components/headers')
